/**
 * Right Sidebar Widgets Component
 * Ambient context shown on every page: streak, today's prompt, top responses,
 * who to follow, and community pulse. Logged-out visitors see a prompt teaser
 * and a login card instead.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthenticationContext';
import PromptUserToLoginCard from '../user/PromptUserToLoginCard';
import WhoToFollowWidget from './WhoToFollowWidget';
import WritingStreakWidget from './WritingStreakWidget';
import TodaysPromptWidget from './TodaysPromptWidget';
import TopResponsesWidget from './TopResponsesWidget';
import CommunityPulseWidget from './CommunityPulseWidget';
import './RightSidebarWidgets.css';

const RightSidebarWidgets = () => {
  const { token } = useAuth();
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get('/api/prompts/daily')
      .then((res) => { if (active) setPrompt(res.data); })
      .catch(() => { /* ignore */ });
    return () => { active = false; };
  }, []);

  return (
    <div className="right-sidebar">
      <div className="sidebar-content">
        {token ? (
          <>
            <WritingStreakWidget />
            <TodaysPromptWidget prompt={prompt} />
            <TopResponsesWidget prompt={prompt} />
            <WhoToFollowWidget />
            <CommunityPulseWidget prompt={prompt} />
          </>
        ) : (
          <>
            <TodaysPromptWidget prompt={prompt} />
            <PromptUserToLoginCard />
            <CommunityPulseWidget prompt={prompt} />
          </>
        )}

        <div className="sidebar-footer">
          <p className="footer-text">WriteFlow</p>
          <p className="footer-subtext">One prompt a day to get your writing flowing</p>
        </div>
      </div>
    </div>
  );
};

export default RightSidebarWidgets;
